import { NgModule } from '@angular/core';

import {
  PostFeldOptionCommandServiceModule,
  PostFeldOptionCommandComponentModule
} from '.';

@NgModule({
  imports: [
    PostFeldOptionCommandServiceModule,
    PostFeldOptionCommandComponentModule
  ],
  exports: [
    PostFeldOptionCommandServiceModule,
    PostFeldOptionCommandComponentModule
  ]
})
export class PostFeldOptionCommandModule { }
